import { useEffect } from 'react';
import type { MediaLang } from './media';

/** Nicole's booking page. A plain link, no embed, so no third-party cookies (concept D5). */
export const DEMO_URL = 'https://calendly.com/nicole-hofsync/30min';

/** D5 open: switch to the domain the inbox actually runs on once decided. */
export const CONTACT_EMAIL = 'nicole@hofsync.com';

const PATHS: Record<'company' | 'security', Record<MediaLang, string>> = {
  company: { de: '/unternehmen', en: '/company' },
  security: { de: '/sicherheit', en: '/security' },
};

/** A v2 page's path under the site's `base` (`/home_v2` for the draft, empty for the homepage). */
export const v2Path = (page: 'company' | 'security', lang: MediaLang, base = '/home_v2'): string =>
  `${base}${PATHS[page][lang]}`;

/** Sets the tab title for a v2 page and restores the previous one on leave. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
